import { z } from 'zod';
import { baseObjectSchema } from '../baseSchemas';

export const dcDocumentTypeSchema = baseObjectSchema.extend({
  documentTypeId: z.string().nullish(),
  representativeId: z.string().optional(),
  documentTypeRemotedCode: z.string(),
  toApprove: z.boolean(),
  allowUpdate: z.boolean().optional(),
  allowChange: z.boolean().optional(),
  exportMethodType: z.number(),
  lastExportedDate: z.string().optional(),
  exportFolder: z.string().optional(),
  exportUrl: z.string().optional(),
  exportFileNameFormat: z.string().optional(),
  documentType: z
    .object({
      id: z.string(),
      name: z.string(),
      code: z.string().optional(),
    })
    .optional(),
});

export const getDCDocumentTypesResponseSchema = z.object({
  data: z.array(dcDocumentTypeSchema),
  count: z.number(),
});

export type GetDCDocumentTypesResponse = z.infer<typeof getDCDocumentTypesResponseSchema>;
